var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 68,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "M45.231 7.052 28.57 3.205a2.85 2.85 0 0 0-3.418 2.136l-1.282 5.553a2.85 2.85 0 0 0 2.136 3.418l16.661 3.847a2.85 2.85 0 0 0 3.418-2.136l1.282-5.553a2.85 2.85 0 0 0-2.136-3.418"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m46.725 13.252 5.554 1.282a5.7 5.7 0 0 1 4.272 6.836l-8.975 38.873a5.7 5.7 0 0 1-6.836 4.271L7.417 56.821a5.7 5.7 0 0 1-4.271-6.835l8.974-38.874a5.7 5.7 0 0 1 6.836-4.271l5.554 1.282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#DADAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6,
    d: "m20.878 36.528 4.272 6.836 13.672-8.542"
  })));
};
export default SvgTask;